import { useEffect, useRef } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const OnboardingPopup = ({ onClick }: { onClick: () => void }) => {
  const popupRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const popupElement = popupRef.current;
    if (popupElement) {
      const height = popupElement.offsetHeight;
      popupElement.style.setProperty("--arrow-top", `${height}px`);
    }
  }, []);

  return (
    <div className="relative z-10 mb-[13px]">
      <div
        ref={popupRef}
        className="w-[320px] rounded-lg bg-[#191B1F] py-2 pl-4 pr-2 text-white dark:bg-[#F7F9FA]"
      >
        <div className="absolute right-2 top-2">
          <button type="button" className="-mt-1" onClick={onClick}>
            <Icon type="hw-tooltip-close" />
          </button>
        </div>
        <Typography.BodySm
          color="text-[#F7F9FA] dark:text-[#191B1F]"
          weight="font-medium"
        >
          {t("help_widget.onboarding_msg_line_1")}
          <br />
          {t("help_widget.onboarding_msg_line_2")}
        </Typography.BodySm>
      </div>
      <div className="absolute bottom-[-7px] right-[124px] size-[15px] rounded-full bg-[#191B1F] dark:bg-[#F7F9FA]" />
      <div className="absolute bottom-[-15px] right-[116px] size-[10px] rounded-full bg-[#191B1F] dark:bg-[#F7F9FA]" />
    </div>
  );
};
